import React from 'react';
export const content = (
  <React.Fragment>
    <p>
      Food is the fuel that helps puppies grow and thrive and the best place to start when
      evaluating foods for your puppy, is to look for foods that are made specifically for puppies.
      These foods have been purposefully formulated to support the growth and nutritional needs of
      puppies. If you have concerns about any special nutritional needs for your puppy, talk with
      your veterinarian.
    </p>
    <p>
      And don’t forget to regularly clean your puppy’s food and water bowl. Bacteria can easily grow
      on your dog’s bowls if items are not cleaned on a regular basis.
    </p>
  </React.Fragment>
);
